import React from 'react';
import {Link} from 'react-router-dom';
import {withFirebase} from '../Firebase';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import {AuthUserContext, withAuthorization} from '../Session';

import 'react-tabs/style/react-tabs.css';
import * as ROUTES from "../../constants/routes";

const Landing = () => (
    <AuthUserContext.Consumer>
        {authUser => (
            <div className="min-h-screen bg-gray-50">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    {/* Welcome Card */}
                    <div className="card mb-8">
                        <div className="text-center mb-8">
                            <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-100 rounded-full mb-4">
                                <svg className="w-10 h-10 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                </svg>
                            </div>
                            <h1 className="text-3xl font-bold text-gray-900 mb-2">
                                Digitalna Kartica
                            </h1>
                            <p className="text-lg text-gray-600">
                                Dobro dosli na web aplikaciju
                            </p>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-4 mb-6">
                            <div className="flex items-center gap-3">
                                <div className="flex-shrink-0">
                                    <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
                                        <svg className="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Signed in as</p>
                                    <p className="font-medium text-gray-900">{authUser.email}</p>
                                </div>
                            </div>
                        </div>

                        <ValueCampaignForm authUser={authUser}/>
                    </div>
                </div>
            </div>
        )}
    </AuthUserContext.Consumer>
);

class ValueCampaignFormBase extends React.Component {
    constructor(props) {
        super(props);

        this.companyUnsub = null

        this.state = {
            company: null,
            loading: false,
            pinGenerated: false,
            showPinModal: false
        };

        this.generatePin = this.generatePin.bind(this);
        this.importMetalacStores = this.importMetalacStores.bind(this);
    }

    handleClose = () => {
        this.setState({showPinModal: false});
    }

    handleShow = () => {
        this.setState({
            showPinModal: true,
            pinGenerated: false
        });
    }

    componentDidMount() {
        this.setState({loading: true});

        this.companyUnsub = this.props.firebase.company(this.props.authUser.uid).onSnapshot(docSnapshot => {
            console.log(`Received doc snapshot: ${docSnapshot}`);
            this.setState({
                company: docSnapshot.data(),
                loading: false
            });
        }, err => {
            console.log(`Encountered error: ${err}`);
        });
    }

    componentWillUnmount() {
        if (this.companyUnsub !== null) this.companyUnsub()
    }

    importMetalacStores() {
        let stores = [
            {
                "name": "Pr.87 Apatin",
                "storeId": 243187,
                "zip": 25260,
                "Latitude": 45.6741114,
                "Longitude": 18.97881484,
                "companyUid": "rftyEcoF57d5H2gD0Rcqqa2ngV63"
            },
            {
                "name": "Pr.88 Backa Palanka",
                "storeId": 243188,
                "zip": 21400,
                "Latitude": 45.25001611,
                "Longitude": 19.39242877,
                "companyUid": "rftyEcoF57d5H2gD0Rcqqa2ngV63"
            }
        ];
        for (let i = 0; i < stores.length; i++) {
            let importObj = {
                name: stores[i].name,
                storeId: stores[i].storeId,
                zip: stores[i].zip,
                companyUid: stores[i].companyUid,
                location: this.props.firebase.geoPoint(parseFloat(stores[i].Latitude), stores[i].Longitude),
            }
            console.log(importObj);
            //this.props.firebase.stores().add(importObj);
        }
    }

    generatePin() {
        const {company} = this.state;
        var newPIN = Math.floor(100000 + Math.random() * 900000) + "";
        localStorage.setItem('localStoragePin', newPIN);
        this.props.firebase.company(this.props.authUser.uid).update({twoStepAuthCode: newPIN});
        this.props.firebase.email().add({
            to: 'office@digitalnakartica.com',
            message: {
                subject: 'Digitalna Kartica PIN Created',
                html: 'Company name: ' + company.name + '\n<br>Digitalna Kartica PIN: ' + newPIN,
            },
        });
        var emailHackForMetalac = company.email;
        if (emailHackForMetalac === 'digital@metalac.com') {
            emailHackForMetalac = 'dk@metalac.com';
        }
        this.props.firebase.email().add({
            to: emailHackForMetalac,
            message: {
                subject: 'Digitalna Kartica PIN',
                html: 'Digitalna Kartica PIN: ' + newPIN,
            },
        });

        this.setState({
            pinGenerated: true,
            showPinModal: false
        });
    }

    render() {
        const {company, loading, pinGenerated, showPinModal} = this.state;

        return (
            <div className="space-y-4">
                {/* Quick Actions */}
                <div className="grid gap-4 sm:grid-cols-2">
                    <button
                        onClick={this.handleShow}
                        className="flex items-center gap-3 p-4 bg-warning-50 border border-warning-200 rounded-xl hover:bg-warning-100 transition-colors text-left"
                    >
                        <div className="flex-shrink-0 w-10 h-10 bg-warning-500 rounded-lg flex items-center justify-center">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                            </svg>
                        </div>
                        <div>
                            <p className="font-medium text-gray-900">Generate PIN</p>
                            <p className="text-sm text-gray-500">Create a new security PIN</p>
                        </div>
                    </button>

                    <Link
                        to={ROUTES.REGISTER_MULTI_FACTOR}
                        className="flex items-center gap-3 p-4 bg-primary-50 border border-primary-200 rounded-xl hover:bg-primary-100 transition-colors text-left no-underline"
                    >
                        <div className="flex-shrink-0 w-10 h-10 bg-primary-500 rounded-lg flex items-center justify-center">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                        </div>
                        <div>
                            <p className="font-medium text-gray-900">Multi-Factor Auth</p>
                            <p className="text-sm text-gray-500">Register phone for MFA</p>
                        </div>
                    </Link>
                </div>

                {/* Status Messages */}
                {loading && (
                    <div className="flex items-center justify-center py-4">
                        <div className="flex items-center gap-2 text-gray-500">
                            <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                            </svg>
                            <span>Loading...</span>
                        </div>
                    </div>
                )}

                {pinGenerated && (
                    <div className="bg-success-50 border border-success-200 rounded-lg p-4 flex items-center gap-3">
                        <svg className="w-5 h-5 text-success-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-success-700 font-medium">PIN Generated! Check your email for the new PIN.</p>
                    </div>
                )}

                {/* PIN Generation Modal */}
                <Modal show={showPinModal} onHide={this.handleClose} centered>
                    <Modal.Header closeButton className="border-b border-gray-200">
                        <Modal.Title className="text-lg font-semibold text-gray-900">
                            Generate New PIN
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-6">
                        <div className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-12 h-12 bg-warning-100 rounded-full flex items-center justify-center">
                                <svg className="w-6 h-6 text-warning-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">Are you sure?</h3>
                                <p className="text-gray-600">
                                    This will log out all web portal users and require them to enter the new PIN.
                                </p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="border-t border-gray-200 bg-gray-50">
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="warning" onClick={this.generatePin}>
                            Generate PIN
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const ValueCampaignForm = withFirebase(ValueCampaignFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Landing);
